var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadDocumenti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "251px",
    height: "189px",
    viewBox: "0 0 251 189",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-10.1%",
    y: "-7.7%",
    width: "120.2%",
    height: "115.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.352941176   0 0 0 0 0.407843137   0 0 0 0 0.447058824  0 0 0 0.43 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-10.1%",
    y: "-7.7%",
    width: "120.2%",
    height: "115.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.352941176   0 0 0 0 0.407843137   0 0 0 0 0.447058824  0 0 0 0.43 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-10.1%",
    y: "-7.7%",
    width: "120.2%",
    height: "115.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.352941176   0 0 0 0 0.407843137   0 0 0 0 0.447058824  0 0 0 0.43 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-Human/Standing",
    transform: "translate(-11.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head/Front",
    transform: "translate(37.720000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(24.840000, 14.262911)",
    fill: "#B28B67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.545937,4.20246679 C20.21155,9.171997 19.8948059,21.7776225 16.4497386,22.6658162 C15.0758624,23.0200235 12.149111,22.1523679 9.1703482,20.3565816 L11.04,33.5868545 L0,33.5868545 L3.80047499,15.8684961 C1.68093044,13.3799995 0.246398452,10.3303398 0.486117114,6.91311963 C1.1768319,-2.93310806 14.8803241,-0.767063418 17.545937,4.20246679 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.4007469,13.6282441 C39.4983421,13.8939908 42.2643461,14.8387244 43.0482539,15.3997784 C43.0482539,18.3329802 42.4800203,19.2032525 37.6265306,19.1265413 C36.4342215,19.7563509 35.5175715,20.8407786 34.5628938,22.262478 C34.9847042,28.1510089 36.1026034,31.0953051 37.9158641,31.0953051 C40.635755,31.0953051 42.9433893,29.3682739 44.1368121,29.3682739 C45.0067768,29.3682739 44.8125404,30.4571764 44.2358823,31.2645202 C43.7601208,31.9306048 41.443202,32.5726308 41.443202,33.6052856 C41.443202,34.121613 41.9008415,34.1800497 42.358481,34.1859604 L42.6053519,34.1864117 C42.9674063,34.1865843 43.27376,34.200933 43.27376,34.4514797 C43.27376,35.4645424 43.5954778,37.3692815 41.8375631,37.3692815 C40.0584948,37.3692815 34.9575907,36.7208225 34.0834339,34.0798322 C33.5193509,32.3756323 33.1546051,28.8444449 32.9891967,23.48627 C32.8817549,23.4714198 32.7716517,23.4647887 32.66,23.4647887 C31.1356941,23.4647887 29.9,24.7007351 29.9,26.2253521 C29.9,26.9993305 30.2184543,27.6989147 30.7314569,28.2001736 C30.0928303,29.1017746 29.3771131,30.0436176 28.5569777,31.0154772 C25.4759065,29.1665825 23.1895764,23.7541746 26.2018236,18.5547947 C27.0344182,16.0076994 28.9192959,14.6472 31.1453818,14.0154765 C32.9486261,13.2610197 34.8205644,13.175954 36.4007469,13.6282441 Z",
    id: "Hair",
    fill: "#191847"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom/Skinny-Jeans-1",
    transform: "translate(0.000000, 86.037559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4431777,-4.43920272 C86.6438711,2.73468559 89.9850794,65.6252452 89.3977201,66.4170975 C89.1366716,66.7690318 75.1926991,69.7648074 47.5658029,75.4044243 L48.7577968,80.2718958 C81.0737513,78.6650633 98.1735749,76.6623028 100.057268,74.2636145 C102.754176,70.8293797 106.088846,51.6240186 110.061278,16.6475311 L95.4431777,-4.43920272 Z",
    id: "Leg",
    fill: "#BA8B72",
    transform: "translate(78.813540, 37.916347) rotate(-55.000000) translate(-78.813540, -37.916347) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2213511,70.2815535 L54.3209889,78.1209511 C78.4096736,80.8844649 94.2902793,77.4594063 99.8804086,72.1421415 C103.607161,68.5972983 106.950409,49.4441319 109.910151,14.6826421 L94.2722892,-7.65053917 C73.3262375,8.15167417 85.8056699,59.8736502 85.2703126,61.0571905 C84.7349552,62.2407307 72.0309732,63.1777651 52.2213511,70.2815535 Z",
    id: "Pant",
    fill: "#2F3676",
    transform: "translate(81.065751, 35.725194) rotate(-55.000000) translate(-81.065751, -35.725194) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(88.726601, 76.964103)",
    fill: "#E4E4E4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Show",
    transform: "translate(14.030000, 9.201878) rotate(20.000000) translate(-14.030000, -9.201878) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.827622697,12.8650814 C0.582540899,13.6653461 0.46,14.3008601 0.46,14.7716232 C0.46,15.6013042 0.598190534,16.8120151 0.874571602,18.4037559 C1.83686334,18.4037559 10.4851412,18.4037559 26.8194052,18.4037559 C27.4936195,16.1743742 27.1044239,14.9708028 25.6518185,14.7930416 C24.1992131,14.6152805 22.9925091,14.4547763 22.0317066,14.3115293 L10.4802939,9.16080078 C9.97588187,8.93588546 9.3846452,9.16246235 9.15972988,9.66687443 C9.15586213,9.67554853 9.15211815,9.68427729 9.14849908,9.69305805 L8.58507802,11.0600569 L8.58507802,11.0600569 C7.24034536,11.6876052 6.14761046,12.0013794 5.30687332,12.0013794 C4.8180911,12.0013794 4.19605049,11.8600971 3.4407515,11.5775324 L3.44075633,11.5775195 C2.40620603,11.1904843 1.25378325,11.7153989 0.866748006,12.7499492 C0.852542331,12.7879212 0.839494532,12.8263163 0.827622697,12.8650814 Z",
    id: "shoe"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Leg",
    fill: "#D4A181",
    points: "59.8 0 35.9968573 57.1560427 12.6020729 105.476659 18.1216597 105.476659 78.5098964 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left-Shot",
    transform: "translate(11.040000, 91.558685)",
    fill: "#E4E4E4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.827622697,12.8650814 C0.582540899,13.6653461 0.46,14.3008601 0.46,14.7716232 C0.46,15.6013042 0.598190534,16.8120151 0.874571602,18.4037559 C1.83686334,18.4037559 10.4851412,18.4037559 26.8194052,18.4037559 C27.4936195,16.1743742 27.1044239,14.9708028 25.6518185,14.7930416 C24.1992131,14.6152805 22.9925091,14.4547763 22.0317066,14.3115293 L10.4802939,9.16080078 C9.97588187,8.93588546 9.3846452,9.16246235 9.15972988,9.66687443 C9.15586213,9.67554853 9.15211815,9.68427729 9.14849908,9.69305805 L8.58507802,11.0600569 L8.58507802,11.0600569 C7.24034536,11.6876052 6.14761046,12.0013794 5.30687332,12.0013794 C4.8180911,12.0013794 4.19605049,11.8600971 3.4407515,11.5775324 L3.44075633,11.5775195 C2.40620603,11.1904843 1.25378325,11.7153989 0.866748006,12.7499492 C0.852542331,12.7879212 0.839494532,12.8263163 0.827622697,12.8650814 Z",
    id: "shoe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.7147325,95.4386062 L26.9793155,97.7390757 C36.4622567,83.7945432 76.1487529,26.6172781 80.5,1.3076655e-14 L53.1962736,1.3076655e-14 C38.6652451,19.241597 23.7539339,81.2634044 14.7147325,95.4386062 Z",
    id: "Pant",
    fill: "#5C63AB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body/Long-Sleeve-1",
    transform: "translate(10.120000, 37.727700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5291534,31.8238322 L101.202358,42.600887 C105.182033,43.6749662 108.506923,45.0113021 111.177028,46.6098947 C111.807753,47.1847384 112.570044,48.3488922 109.954274,48.1476973 C107.338504,47.9465024 104.578061,47.8525404 104.217135,48.744921 C103.85621,49.6373017 105.439132,50.7044911 104.709545,51.9085464 C104.223153,52.7112498 101.925244,50.6985006 97.815817,45.8702988 L83.2854951,39.8437113 L86.5291534,31.8238322 Z M115.201619,-7.81100659 L114.866422,-7.42818249 C113.252011,-5.57089849 111.762415,-3.64087639 112.225789,-2.86877033 C112.72112,-2.04341557 114.525868,-2.66560076 115.048197,-1.35818892 C115.396416,-0.48658103 112.406374,0.13768279 106.078073,0.514602539 L92.5214425,8.49451139 L88.0698716,1.07699823 L105.505609,-4.15814261 C108.75826,-6.69070434 111.826256,-8.54239459 114.709598,-9.71321336 C115.548174,-9.87108606 116.936477,-9.77939741 115.201619,-7.81100659 Z",
    id: "Skin",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4118797,7.19964082 C69.9871225,19.5259917 84.1046721,27.5698141 103.35858,34.704977 L99.0833912,43.2558821 C79.2180647,41.3815302 68.5976785,39.8848252 60.2713123,27.5396285 C58.1815632,24.4412345 54.4447066,13.7804183 52.206098,8.24422506 L58.4118797,7.19964082 Z",
    id: "Coat-Back",
    fill: "#2F3676",
    transform: "translate(77.782339, 25.227761) rotate(15.000000) translate(-77.782339, -25.227761) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4,52.4507042 L76.82,52.4507042 C68.7967769,27.9761847 64.69821,11.178396 64.5242992,2.05733815 C64.515433,1.5923378 63.6568141,0.772941516 63.2769423,0.880248753 C60.4989808,1.66497501 57.5263427,1.37155876 54.359028,0 C45.9620431,13.5076238 43.0582201,30.1382436 41.4,52.4507042 Z",
    id: "Shirt",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.004431,-4.14084507 L104.88,5.23286889 C90.5216473,14.4693334 75.9826082,21.624286 63.2428667,20.6078881 C68.7757302,44.3420744 68.5208087,63.7717591 56.3074373,63.7717591 L56.3074373,63.7717591 L37.4215183,63.7717591 C34.4219985,43.6095155 42.3053237,15.6540577 49.6137393,1.55355042 C49.8928257,1.01509452 50.4870286,-1.70530257e-13 51.8866203,-1.70530257e-13 L51.8866203,-1.70530257e-13 L57.3743111,-1.70530257e-13 C57.3767446,0.00732843425 57.3791776,0.0146568623 57.3816104,0.0219852836 C67.5342012,0.104922141 84.0068394,1.95944623 103.004431,-4.14084507 Z",
    id: "Coat-Front",
    fill: "#5C63AB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    filter: "url(#filter-1)",
    transform: "translate(114.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E4EAF0",
    x: 0,
    y: 0,
    width: 119,
    height: 155,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(15.000000, 19.000000)",
    fill: "#9DA6AD"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 89,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 22,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 33,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 0,
    y: 43,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 0,
    y: 53,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 0,
    y: 71,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 0,
    y: 120,
    width: 86,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 40,
    y: 22,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 40,
    y: 33,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 40,
    y: 43,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 40,
    y: 53,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 40,
    y: 71,
    width: 46,
    height: 5,
    rx: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    filter: "url(#filter-2)",
    transform: "translate(121.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E4EAF0",
    x: 0,
    y: 0,
    width: 119,
    height: 155,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(15.000000, 19.000000)",
    fill: "#9DA6AD"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 89,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 22,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 33,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 0,
    y: 43,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 0,
    y: 53,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 0,
    y: 71,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 0,
    y: 120,
    width: 86,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 40,
    y: 22,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 40,
    y: 33,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 40,
    y: 43,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 40,
    y: 53,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 40,
    y: 71,
    width: 46,
    height: 5,
    rx: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-2",
    filter: "url(#filter-3)",
    transform: "translate(130.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E4EAF0",
    x: 0,
    y: 0,
    width: 119,
    height: 155,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(15.000000, 19.000000)",
    fill: "#C9D9E8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 86,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 22,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 33,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 0,
    y: 43,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 0,
    y: 53,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 0,
    y: 71,
    width: 35,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 0,
    y: 120,
    width: 86,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 40,
    y: 22,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 40,
    y: 33,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 40,
    y: 43,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 40,
    y: 53,
    width: 46,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 40,
    y: 71,
    width: 46,
    height: 5,
    rx: 2.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadDocumenti);
export default __webpack_public_path__ + "static/media/Head-Documenti.f1188c951683d7a66f7ba338358c241c.svg";
export { ForwardRef as ReactComponent };